/**
 * viewNotifications.js
 * Written by: Alex Kasemir
 */
import request from 'store/request/actions';

import notViewedNotifications from '../../selectors/notViewedNotifications';

export const VIEW_NOTIFICATIONS_START = `VIEW_NOTIFICATIONS_START`;
export const VIEW_NOTIFICATIONS_SUCCESS = `VIEW_NOTIFICATIONS_SUCCESS`;
export const VIEW_NOTIFICATIONS_FAILURE = `VIEW_NOTIFICATIONS_FAILURE`;

export const viewNotificationsStart = (data) => ({
  type: VIEW_NOTIFICATIONS_START,
  data,
});

export const viewNotificationsSuccess = () => ({
  type: VIEW_NOTIFICATIONS_SUCCESS,
});

export const viewNotificationsFailure = (error) => ({
  type: VIEW_NOTIFICATIONS_FAILURE,
  error,
});

/**
 * Description of the viewNotifications action
 */
export const viewNotifications = () => {
  return (dispatch, getState) => {
    const notifications = notViewedNotifications(getState());
    dispatch(viewNotificationsStart(notifications));
    const ids = notifications.map((n) => n.id);
    const payload = {
      ids,
    };

    if (ids.length) {
      dispatch(request(`/notifications/view/`, `POST`, payload))
        .then(() => {
          dispatch(viewNotificationsSuccess());
        })
        .catch((error) => {
          dispatch(viewNotificationsFailure(error));
        });
    }
  };
};
